import Vue from 'vue'

const state = {
	active: false
}

const getters = {
	get: state => state
}

const actions = {
  show ({commit}) {
    // cover
    this.dispatch('core/showSclCover')
    // show
    commit('showed')
  },
  hide ({commit}) {
    if (!state.active) return
    // hide
    commit('hided')
    // cover
    setTimeout(() => {
      this.dispatch('core/hideSclCover')
    }, 350)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  showed (state) {
    state.active = true
  },
  hided (state) {
    state.active = false
  },

  // reset
  reset (state) {
    
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
